import { ContentStrategyType } from 'types'
import { ContentStrategyTypeEmojiProps } from 'components/ContentStrategyTypeEmoji/Types'
import { filterDOMProps } from '@react-aria/utils'

export const EmojiMap: Record<ContentStrategyType, string> = {
  [ContentStrategyType.EducationalContent]: '📚',
  [ContentStrategyType.QuickTips]: '💡',
  [ContentStrategyType.ThoughtLeadership]: '💭',
  [ContentStrategyType.LifestyleContent]: '🎿',
  [ContentStrategyType.ProblemSolution]: '🧰',
  [ContentStrategyType.ProductEducation]: '😎',
  [ContentStrategyType.OfferAndServices]: '🛍️',
  [ContentStrategyType.OfferAndPromotion]: '🛍️',
}

export const ContentStrategyTypeEmoji = ({ contentStrategyType, color, ...props }: ContentStrategyTypeEmojiProps) => {
  return (
    <span
      {...filterDOMProps(props)}
      style={{
        color: color || 'inherit',
      }}
    >
      {EmojiMap[contentStrategyType]}
    </span>
  )
}
